import withUrlParams from "hocs/withUrlParams"
import createModule from "../createModule"
import { getToken, getValidToken, getMfaEnabled, getPasswordExpired } from "./selectors/index"
import view from "./view"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    queryToken: getToken(state, props),
  }),
  data: [{
    resource: "resetPasswordUser",
    as: null,
    noToken: true,
    url: ({ queryToken }) => `/api/users/reset-password/${queryToken}`,
  }],
  mapStateToProps: (state, props) => ({
    token: getValidToken(state, props),
    mfaEnabled: getMfaEnabled(state, props),
    passwordExpired: getPasswordExpired(state, props),
  }),
}))
